const CONTENT_TYPE = {
  PARTICIPANT_JOINED: 'application/vnd.amazonaws.connect.event.participant.joined',
  CHAT_ENDED: 'application/vnd.amazonaws.connect.event.chat.ended'
};

const _scrollToBottom = (container) => {
  const messages = container.querySelector('.aws-chatkit-messages');
  if (messages) messages.scrollTop = messages.scrollHeight;
};

export const appendEvent = (container, text) => {
  const messages = container.querySelector('.aws-chatkit-messages');
  if (!messages) return;

  const div = document.createElement('div');
  div.className = 'aws-chatkit-event';
  div.textContent = text;
  messages.appendChild(div);
  _scrollToBottom(container);
};

export const appendMessage = (container, type, text, senderName) => {
  const messages = container.querySelector('.aws-chatkit-messages');
  if (!messages) return;

  const group = document.createElement('div');
  group.className = `aws-chatkit-message-group ${type}`;

  if (senderName) {
    const sender = document.createElement('div');
    sender.className = 'aws-chatkit-message-sender';
    sender.textContent = senderName;
    group.appendChild(sender);
  }

  const bubble = document.createElement('div');
  bubble.className = 'aws-chatkit-bubble';
  bubble.textContent = text;
  group.appendChild(bubble);

  messages.appendChild(group);
  _scrollToBottom(container);
};

const _processAwsEvent = (container, content) => {
  if (content.ContentType === CONTENT_TYPE.PARTICIPANT_JOINED && content.ParticipantRole === 'CUSTOMER') {
    appendEvent(container, 'You have joined the chat');
  } else if (content.ContentType === CONTENT_TYPE.CHAT_ENDED) {
    appendEvent(container, 'The chat has ended');
  }
};

const _processAwsMessage = (container, content) => {
  const type = content.ParticipantRole === 'CUSTOMER' ? 'customer' : 'agent';
  appendMessage(container, type, content.Content, content.DisplayName);
};

export const processWebsocketContent = (container, content) => {
  if (content.Type === 'EVENT') {
    _processAwsEvent(container, content);
  } else if (content.Type === 'MESSAGE') {
    _processAwsMessage(container, content);
  }
};
